const transformPostCrmRegisterResponse = ({ id , group_id , email , firstname , lastname  })=>({
        id,
        groupId: group_id,
        firstname,
        lastname,
        email
    });

export { transformPostCrmRegisterResponse };
